<template>
  <div>
    <div class="flex return_btn" @click="handleReturn">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.41658 3.33398L2.5 5.83398L5.41658 8.75065" stroke="#006838" stroke-width="1.5"
          stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M2.5 5.83398H12.0807C14.9487 5.83398 17.3842 8.17582 17.496 11.0423C17.6141 14.0713 15.1113 16.6673 12.0807 16.6673H10H4.99933"
          stroke="#006838" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span style="font-size: 16px;">返回云流程</span>
    </div>
    <div class="flex" style="justify-content: space-between;margin-top: 30px;align-items: flex-start;">
      <div class="flex info_left">
        <div class="flex logo_box">
          <img :src="props.rawData.System_conf.img" alt="">
          <!--  <img src="./img/logo.png" alt=""> -->
        </div>
        <div class="flex-column project_info">
          <!--  <div class="project_name">医学宏基因组云分析</div>
          <div class="project_intro">
            代谢组学(metabolomics)是继基因组学和蛋白质组学之后新近发展起来的一门学科，是系统生物学的重要组成部分，其研究对象大都是相对分子质量1500以内的小分子物质。代谢组学的技术平台主要分为NMR,LC-MS和GC-MS。LC-MS适合检测大部分代谢物，技术成熟稳定，是研究代谢变化的主流技术。
          </div> -->

          <div class="project_name">{{props.rawData?.name_zh}}</div>
          <div class="project_intro">{{props.rawData?.intro}}</div>

        </div>
      </div>
      <div>
        <div class="gray_text">发布日期：{{ formatDate(props.rawData?.report_tree?.created_at)}}</div>
        <!-- <div class="gray_text">发布日期：{{ props.rawData?.report_tree?.created_at}}</div> -->
      </div>
    </div>

    <!-- <div style="margin-top: 50px;">
      <template v-for="(item, index) in form_list" :key="index">
        <div>
          <div class="flex item_head">
            <div class="item_index">{{ index + 1 }}</div>
            <div class="item_title">{{ item.title }}</div>
            <el-popover class="box-item" title="提示" :content="item.pro" placement="top-start">
              <template #reference>
                <img src="./img/Frame.png" alt="">
              </template>
            </el-popover>
          </div>

          <div class="item_content">
            <div class="item_intro" v-if="item.intro">{{ item.intro }}</div>
            <div>
              <template v-if="item.type === 'SelectFile'">
                <SelectFile></SelectFile>
              </template>
              <template v-else-if="item.type === 'FileData'">
                <FileData></FileData>
              </template>
              <template v-else-if="item.type === 'GroupData'">
                <GroupData></GroupData>
              </template>
              <template v-else-if="item.type === 'ComparePlan'">
                <ComparePlan></ComparePlan>
              </template>
              <template v-else-if="item.type === 'FormData'">
                <DynamicForm ref="dynamicForm" :schema="schema" />
              </template>
            </div>
          </div>

        </div>
      </template>
    </div> -->

    <div style="margin-top: 50px;">
      <DynamicForm ref="dynamicForm" :schema="schema" />
    </div>

    <div class="submit_btns">
      <el-button @click="openHelp">使用说明</el-button>
      <!-- <el-button>保存方案</el-button> -->
      <el-button @click="exportPlan" :loading="export_loading">导出方案</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="is_submit_loading">
        <!-- <img src="./img/submit.svg" alt="" style="margin-right:10px;"> -->
        提交分析任务
      </el-button>
    </div>


    <el-dialog v-model="dialogVisible" title="使用说明" width="1200" :before-close="handleClose">
      <div v-if="help_doc_info" v-html="help_doc_info" style="max-height: 800px;overflow-y: auto;">
      </div>
      <el-empty v-else description="暂无数据" />
      <template #footer>
        <div class="dialog-footer">
          <!--   <el-button @click="dialogVisible = false">Cancel</el-button> -->
          <el-button type="primary" @click="dialogVisible = false">
            关闭
          </el-button>
        </div>
      </template>
    </el-dialog>

  </div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';
  import { ElMessage } from "element-plus";
  import SelectFile from "../FormComs/SelectFile.vue";
  import FileData from "../FormComs/FileData.vue";
  import GroupData from "../FormComs/GroupData.vue";
  import ComparePlan from "../FormComs/ComparePlan.vue";
  import DynamicForm from "../FormComs/DynamicForm.vue";
  import { export_plan, start_task } from "@/api/index.js";

  import { saveAs } from 'file-saver'; // 推荐使用 file-saver 库，兼容性好
  import axios from 'axios';
  import { useStore } from '@/Store/index';
  import { useTaskStore, useFormStore } from "@/Store/task.js";

  const store = useStore();
  const taskStore = useTaskStore();
  const formStore = useFormStore();

  const emit = defineEmits([])
  const props = defineProps({
    rawData: {
      type: Object,
    }
  });

  const dialogVisible = ref(false);
  const help_doc_info = ref(null);

  const dynamicForm = ref(null);

  const export_loading = ref(false);

  const is_submit_loading = ref(false);


  const form_list = ref([
    {
      title: "数据选择",
      pro: "选择本地文件上传",
      type: "SelectFile"
    },
    {
      title: "筛选数据(按行)",
      pro: "选择需要展示的数据，支持按行筛选，可多选。",
      /*  intro: "选择需要展示的数据，支持按行筛选，可多选。", */
      type: "FileData"
    },
    {
      title: "分组数据",
      pro: "按指定字段分组数据，可选择分组字段、分组方式、排序方式。",
      intro: `样本和组别的命名需遵循以下规范：命名必须以英文字母开头，长度不超过8个字符，可以包含字母、数字和下划线。组别命名不能使用任何连接符，样本命名如需连接只能使用英文下划线"_"，且不能连续使用多个下划线，命名中不得包含中文、罗马或希腊字符，也不能使用特殊符号如 |、？、：、\、/、@、#、$、%、*、括号"()"、方括号"[]"、中文括号"【】"、大括号"{}"等，同时需符合 Windows 文件命名规则，不允许出现系统禁止的字符。请避免使用可能被系统识别为特殊含义的单词或字符，如 NA、vs/VS/、nan、inf、None、none，并且不能包含文字的上下标。`,
      type: "GroupData"
    },
    {
      title: "设计分析差异方案",
      pro: "分析数据差异，设计差异方案，提升分析结果的可靠性。",
      type: "ComparePlan"
    },
    {
      title: "其他参数",
      type: "FormData"
    },
  ]);

  const schema = [
    {
      key: "gene_read.is_kegg_analysis",
      title: "是否进行KEGG通路分析：",
      assembly_type: "radio",
      default: true,
      is_required: true,
      select_data: [
        { label: "是", value: true },
        { label: "否", value: false }
      ]
    },
    {
      key: "gene_read.kegg_type",
      title: "KEGG通路类型：",
      assembly_type: "radio",
      default: "animals",
      is_required: true,
      select_data: [
        { label: "动物", value: "animals" },
        { label: "微生物", value: "hsa" },
        { label: "植物", value: "plants" },
        { label: "全部", value: "all" }
      ]
    },
    {
      key: "gene_read.vip_threshold",
      title: "VIP筛选阈值",
      assembly_type: "input",
      default: 1.5,
      is_required: true,
      prompt: "0表示不用VIP进行筛选，大于0表示使用VIP筛选差异物质，一般建议设置为1.5。"
    },
    {
      key: "gene_read.diff_threshold",
      title: "差异倍数筛选阈值",
      assembly_type: "input",
      default: 0.67,
      is_required: true,
    },
    {
      key: "gene_read.diff_threshold",
      title: "显著性Pvalue筛选阈值",
      assembly_type: "input",
      default: 0.05,
      is_required: true,
    },
    {
      key: "gene_read.is_show_logo",
      title: "是否展示公司logo：",
      assembly_type: "radio",
      default: true,
      is_required: true,
      select_data: [
        { label: "是", value: true },
        { label: "否", value: false }
      ]
    },
    {
      key: "gene_read.name",
      assembly_type: "input",
      title: "流程任务名称",
      default: "",
      is_required: true
    },
  ];



  // 不要时分秒
  function formatDate(dateTimeStr) {
    return dateTimeStr.split(' ')[0];
  };



  const handleReturn = function () {
    //判断有无，有就发送消息
    if (window.top === window) {
      console.log("无父级页面，不发送消息");
    } else {
      window.parent.postMessage({ type: "go_previous_page", data: {} }, "*");
    }

  };


  const openHelp = function () {
    help_doc_info.value = taskStore?.help_doc_info;
    dialogVisible.value = true;
  };

  const handleClose = function () {
    console.log("关闭弹窗");

  };

  // 导出方案
  const exportPlan = async function () {
    try {
      // 调用子组件暴露的 submit 方法
      const formData = await dynamicForm.value.submit();
      console.log("表单数据：", formData);
      // 后续可以发请求

      const params = {
        filter_data_file: taskStore.filter_data_file,
        metadata_file: taskStore.metadata_file,
        group_plan_file: taskStore.group_plan_file,
        params: {
          ...formData,
        }
      };

      const api_url = `${process.env.VUE_APP_BASE_API}/flow/export_plan`;
      export_loading.value = true;
      const response = await axios.post(
        api_url,
        params,
        {
          // 必须设置为 blob
          responseType: 'blob',
          headers: {
            ticket: store.ticket || '',
          },
        }
      );
      // 从 headers 中获取文件名
      let fileName = 'export.zip';
      const disposition = response.headers['content-disposition'];
      if (disposition && disposition.includes('filename=')) {
        fileName = decodeURIComponent(disposition.split('filename=')[1].replace(/"/g, ''));
      }
      saveAs(response.data, fileName);
      export_loading.value = false;
    } catch (err) {
      console.error(err);
      export_loading.value = false;
    }
  };


  function transformToObject(list) {
    return list.reduce((acc, item) => {
      acc[item.key] = item.default ?? null; // 没有 default 就给 null
      return acc;
    }, {});
  };

  const toPerson = function () {
    if (window.top === window) {
      console.log("无父级页面，不发送消息");
    } else {
      window.parent.postMessage({ type: "go_person_project_page", data: {} }, "*");
    }
  };
  const handleSubmit = async () => {
    console.log("触发了嘛");
    try {
      const values = await dynamicForm.value.submit();
      console.log("输入数据:", values);


      const app_id = store.app_id;//应用id
      const task_id = store.task_id;//任务id
      const process_forms = formStore.process_forms;
      if (!Array.isArray(process_forms) || process_forms.length === 0) {
        return ElMessage.error("未找到流程参数");
      };

      // 生成最终的提交数据
      const finalParams = {};
      process_forms.forEach((field) => {
        if (field.category === "metadata") {
          finalParams[field.key] = taskStore.metadata_file;
        } else if (field.category === "filter_data_row") {
          finalParams[field.key] = taskStore.filter_data_file;
        } else if (field.category === "comparison_group_plan") {
          finalParams[field.key] = taskStore.group_plan_file;
        } else {
          // 普通字段：优先取表单提交的值，否则 fallback 到原始值/默认值
          finalParams[field.key] =
            values[field.key] ?? field.value ?? field.default ?? null;
        }
      });
      console.log("要提交的数据", finalParams);

      const allProcessForms = transformToObject(formStore.all_process_forms);
      const params = {
        input_data: {
          ...allProcessForms,
          ...finalParams
        },
        task_name: values.task_name,
        node_name: taskStore.start_node_name,
        app_id: app_id,
        task_id: task_id,
        is_multi_step: true,
        is_restart: true
      };

      console.log("要提交的最终表单", params);

      /* is_submit_loading.value = true;
      start_task(params).then((result) => {
        console.log("提交结果", result);
        if (result.code == 200) {
          is_submit_loading.value = false;
          ElMessage.success("提交成功");
          toPerson();
        }
      }).catch((err) => {
        console.error(err);
        ElMessage.error("提交失败");
        is_submit_loading.value = false;
      }); */

    } catch (err) {
      console.error(err);
    }
  };


  // 使用 watch 监听 props 的字段变化
  watch(() => props, (newData, oldData) => {
  });
  //组件即将挂载
  onBeforeMount(() => {
  });
  //组件已经挂载
  onMounted(() => {

    console.log("rawData是什么", props.rawData);
  });
  //组件即将更新
  onBeforeUpdate(() => {
  });
  //组件已经更新
  onUpdated(() => {
  });
  //组件即将卸载
  onBeforeUnmount(() => {
  });
  //组件已经卸载
  onUnmounted(() => {
  });
</script>
<style lang="scss" scoped>
  .return_btn {
    width: auto;
    cursor: pointer;
    color: var(--el-color-primary);
    gap: 10px;
    width: max-content;
  }

  .info_left {
    width: calc(100% - 270px);
    /* justify-content: space-between; */
    justify-content: flex-start;
    gap: 40px;

    .logo_box {
      width: 150px;
      height: 150px;
      border-radius: 10px;
      background-color: #f1f5fb;
      justify-content: center;

      img {
        max-width: 100%;
        object-fit: contain;
        object-position: center;
      }
    }
  }

  .project_info {
    /* max-width: 1100px; */

    max-width: calc(100% - 200px);
    justify-content: center;
    gap: 18px;

    .project_name {
      color: #333;
      font-size: 20px;
      font-weight: 500;
    }

    .project_intro {
      color: #333;
      font-size: 16px;
    }
  }




  .item_head {
    height: 70px;
    background-color: #F4F5F6;
    border-radius: 8px;
    padding: 0 24px;
    box-sizing: border-box;
    justify-content: flex-start;
    gap: 30px;

    .item_index {
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fff;
      background-color: var(--el-color-primary);
      border-radius: 100%;
      font-size: 16px;
    }

    .item_title {
      font-size: 20px;
      font-weight: 400;
    }
  }

  .item_content {
    padding: 40px 20px;
    box-sizing: border-box;

    .item_intro {
      color: #333;
      font-size: 16px;
      margin-bottom: 26px;
    }
  }

  .submit_btns {
    text-align: center;

    .el-button {
      height: 40px;
      padding: 0 30px;
      border-radius: 30px;
    }
  }
</style>